module.exports = __webpack_public_path__ + "static/security-f55108efebb9459daca19e0486490164.png";